import { apiEnums } from '@nodal/api';
import { t } from '@nodal/i18n';

import type { ScreenStep } from './Screening.interface';
import type { ApiModel } from '@nodal/api';
import type { StepProps as Step } from '@nodal/uikit/components/Step';

const screenStatusToStep = new Map<
  ApiModel.ScreenStatusEnum | undefined,
  Pick<Step, 'status' | 'label'>
>([
  [apiEnums.ScreenStatusEnum.Pend, { status: 'pending', label: t('Up Next') }],
  [
    apiEnums.ScreenStatusEnum.Proc,
    { status: 'processing', label: t('In Progress') },
  ],
  [apiEnums.ScreenStatusEnum.Rev, { status: 'pending', label: t('In Review') }],
  [apiEnums.ScreenStatusEnum.App, { status: 'complete', label: t('Complete') }],
  [
    apiEnums.ScreenStatusEnum.Half,
    { status: 'complete', label: t('Complete') },
  ],
  [apiEnums.ScreenStatusEnum.Rej, { status: 'complete', label: t('Complete') }],
]);

// Special status for Identity Check to display "Complete Later"
const completeLaterStatus: Pick<Step, 'status' | 'label'> = {
  status: 'pending',
  label: t('Complete Later'),
};

export const buildDisplaySteps = (
  screeningSteps: ScreenStep[],
  activeStepIndex?: number,
): Step[] =>
  screeningSteps.map((step: ScreenStep, stepIdx: number) => {
    const stepStatus =
      activeStepIndex === stepIdx
        ? apiEnums.ScreenStatusEnum.Proc
        : step.status;

    // Identity Check needs to show "Complete Later" label when API sets is_complete_later=true
    // However, we'll directly check for Identity Check title and Pend status
    const isIdentityCheck = step.title === 'Identity Check';
    const isPendingStatus = stepStatus === apiEnums.ScreenStatusEnum.Pend;

    // For Identity Check in Pending status, show "Complete Later"
    const statusInfo =
      isIdentityCheck && isPendingStatus
        ? completeLaterStatus
        : screenStatusToStep.get(stepStatus);

    return {
      title: step.title || undefined,
      label:
        // NOTE: We would like to show label only for the previous steps and one step after the active one
        stepIdx <= (activeStepIndex ?? 0) + 1 ? statusInfo?.label : undefined,
      status: statusInfo?.status,
      index: stepIdx,
    };
  });
